// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__8rPsq","title":"Hero_title__2_dkF","subTitle":"Hero_subTitle__PDfvo","searchBar":"Hero_searchBar___RS4n","breakLarge":"Hero_breakLarge__LpdMc"};